export default {
	loading                : false,
	userState              : null,
	userProfile            : null,
	userCustomerId         : null,
	userSubscriptionId     : null,
	userSubscriptionSecret : null,
	userSubscriptionPayment: null,
	userPromoCode          : '',
	userQrcode             : '',
	userAuth               : null,
	userRestorePassword    : false
}
